<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeModal">

    <br><br>

    <div class="row">
      <div class='col-6'>
        <label>AccountId: </label> &nbsp; {{ incentifyerAccount ? incentifyerAccount.id : '' }}
      </div>
      <div class='col-6'>
        <label>DateCreated: </label> &nbsp; {{ showDateCreated() }}
      </div>
    </div>

    <br>

    <div class="row">
      <fg-input class="col-6"
                type="text"
                label="Company Name"
                placeholder="Company name"
                v-model="profile.companyName"
                :disabled="incentifyerAccount.archived"
                @keyup.enter="saveIncentifyerAccount()"/>

      <fg-input class="col-6"
                label="Account Type"
                required>
        <el-select v-model="incentifyerAccount.type" class="removeReadonly">
          <el-option v-for="type in accountTypes"
                      :key="type"
                      :label="type"
                      :value="type"
                      @keyup.enter="save()"/>
        </el-select>
      </fg-input>
    </div>
    
    <fg-input label="Notes">
      <el-input type="textarea"
                :autosize="{minRows: 2}"
                placeholder="Notes"
                v-model="incentifyerAccount.notes"
                @keyup.enter="saveIncentifyerAccount()"/>
    </fg-input>

    <!-- <fg-input label="Company">
      <el-select class="select-transparent removeReadonly" v-model="companyId" :filterable="false">
        <el-option v-for="item in $store.getters.companies"
                    :value="item.id"
                    :label="item.profile.companyName"
                    :key="item.id"/>
      </el-select>
    </fg-input> -->


    <span slot="footer" class="dialog-footer">
      <div class="row">
        <span v-if="modalState.mode != 'Create'" class="col-4">
          <button v-if="deletable" class="btn btn-danger" @click="deleteAffiliate()">Delete</button>
          <button v-else-if="incentifyerAccount.archived" class="btn" @click="toggleArchive()">Unarchive</button>
          <button v-else class="btn" @click="toggleArchive()">Archive</button>
          <!-- <button v-else class="btn" @click="test">Archive</button> -->
          &nbsp;<button class="btn btn-info" @click="login()">Login</button>&nbsp;
        </span>

        <span class="ml-auto col-4">
          <button class="btn" @click="closeModal()">Cancel</button>&nbsp;
          <button class="btn btn-success" @click="saveIncentifyerAccount()">Save</button>
        </span>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { Person } from 'src/classes/datamodel.js'
import NProgress from 'nprogress'
import utils from '../../utils'
import { Payout } from '../../classes/datamodel'
export default {
  name: 'Incentifyer-Account-Modal',
  data () {
    return {
      accountTypes: [ 'internal', 'live', 'test', 'trial' ]
    }
  },
  computed: {
    modalState () {
      return this.$store.state.modal
    },
    title () {
      // return 'Incentifyer Account'
      return this.modalState.mode + ' Incentifyer Account'
    },
    visible () {
      return this.modalState.current == 'Incentifyer Account'
    },
    incentifyerAccount () {
      return this.visible && this.modalState.object ? this.modalState.object : {}
    },
    profile () {
      return this.incentifyerAccount ? this.incentifyerAccount.profile || {} : {}
    },
    archived: { get()  { return this.incentifyerAccount.archived; },
                set(archived) { this.incentifyerAccount.archived = archived }
    },
    deletable: { get() { return this.incentifyerAccount.deletable },
                 set(deletable) { this.incentifyerAccount.deletable = deletable }
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('closeModal')
    },
    toggleArchive () {
      this.archived = !this.archived
    },
    showDateCreated () {
      return utils.dateToString(this.incentifyerAccount.dateCreated)
    },
    async login () {
      console.log('login: this.incentifyerAccount = ', this.incentifyerAccount.id)
      const res = await this.$store.dispatch('impersonateIncentifyerAccount', this.incentifyerAccount.id)
      if (res) {
        if (!res.errors) {
          this.$notify({successMessage: 'Saved!'})
          this.closeModal()
          setTimeout(() => window.open(`${process.env.VUE_APP_INCENTIFYER_APP_URL || 'http://localhost:8080'}/login`), 1000)
        }
        else {
          //console.log('res.errors = ', res.errors[0].message)
          if (res.status == 401) {
            this.closeModal()
            this.$router.push('/login')
          }
          else {
            // We don't show the session invalid message because the apiService already reroutes to login page
          if (!res.errors[0] || typeof res.errors[0] != 'string' || !res.errors[0].toLowerCase().includes('session')) {
              this.$notify({errorMessage: res.errors.reduce((accumulator, currentValue) => accumulator + '; ' + currentValue.message)})
            }
          }
        }
      }
    },
    async saveIncentifyerAccount () {
      NProgress.start()
      NProgress.set(0.4)
      const action =  this.$store.state.modal.mode == 'Edit' ? 'updateIncentifyerAccount' : 'createIncentifyerAccount'
      const res = await this.$store.dispatch(action, this.incentifyerAccount)
      console.log('saveIncentifyerAccount(): res = ', res)
      if (res) {
        if (!res.errors) {
          this.$notify({successMessage: 'Saved!'})
          this.closeModal()
        }
        else {
          //console.log('res.errors = ', res.errors[0].message)
          if (res.status == 401) {
            this.closeModal()
            this.$router.push('/login')
          }
          else {
            // We don't show the session invalid message because the apiService already reroutes to login page
          if (!res.errors[0] || typeof res.errors[0] != 'string' || !res.errors[0].toLowerCase().includes('session')) {
              this.$notify({errorMessage: res.errors.reduce((accumulator, currentValue) => accumulator + '; ' + currentValue.message)})
            }
          }
        }
      }
      else {
        console.log('res = ', res)
      }
      NProgress.done()
    }
  },
  watch: {
    visible: function (elem) {
      if (this.visible) {
        // doesn't work without the timeout..
        setTimeout(() => this.$refs.tofocus.$el.children[1].focus(), 500)
      }
    }
  }
}
</script>

<style>

</style>